import React, {Component} from 'react';
import styled from 'styled-components';
import * as THREE from 'three';
import ReactResizeDetector from 'react-resize-detector';
import VisibilitySensor from 'react-visibility-sensor';

const OutroBackgroundStyle = styled.div`
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 66.66vh;
	overflow: hidden;
	
	canvas {
		width: 100%;
		height: 100%;
	}
`;

/**
 * This is a massive clusterfuck of death
 * This increased the size of the first-page-load by 1MB
 * If you need to optimize anything, refactor this.
 */

class OutroThree extends Component {

	constructor(props) {
		super(props);

		this.SEPARATION = 100;
		this.AMOUNTX = 100;
		this.AMOUNTY = 70;
		this.particles = [];
		this.count = 0;
		this.fps = 30;
		this.animationTimer = null;

		this.isVisible = false; // Using as state, but we don't need re-rendering

		this.threeAnimate = this.threeAnimate.bind(this);
		this.threeStopAnimate = this.threeStopAnimate.bind(this);
		this.threeRender = this.threeRender.bind(this);
		this.initThreeScene = this.initThreeScene.bind(this);
		this.onWindowResize = this.onWindowResize.bind(this);
		this.onVisibilityChange = this.onVisibilityChange.bind(this);
	}

	/**
	 * Get everything ready
	 */
	componentDidMount() {
		this.initThreeScene();

		const material = new THREE.MeshBasicMaterial({ color: 0x83F5F8 });
		const geometry = new THREE.CircleBufferGeometry(0.5, 32);

		let i = 0;

		for (let ix = 0; ix < this.AMOUNTX; ix++) {

			for (let iy = 0; iy < this.AMOUNTY; iy++) {

				const particle = new THREE.Mesh(geometry, material);
				this.particles[i++] = particle;
				particle.position.x = ix * this.SEPARATION - (( this.AMOUNTX * this.SEPARATION ) / 2);
				particle.position.z = iy * this.SEPARATION - (( this.AMOUNTY * this.SEPARATION ) / 2);
				this.scene.add(particle);
			}
		}

		if(this.isVisible) {
			this.threeAnimate();
		}
	}

	componentWillUnmount() {
		this.threeStopAnimate();
	}

	/**
	 * Initiates the ThreeJS scene
	 */
	initThreeScene() {
		this.scene = new THREE.Scene();
		this.scene.background = new THREE.Color(0x000000);

		this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight / 1.5, 1, 10000);

		this.renderer = new THREE.WebGLRenderer();
		this.renderer.setSize(window.innerWidth, window.innerHeight / 1.5);

		document.getElementById("three-canvas").appendChild(this.renderer.domElement);
	}

	/**
	 * Starts Animation
	 */
	threeAnimate() {
		this.animationTimer = setTimeout(() => {
			requestAnimationFrame(this.threeAnimate);
		}, 1000 / this.fps);
		this.threeRender();
	}

	/**
	 * Stops Animation
	 */
	threeStopAnimate() {
		if(this.animationTimer) {
			clearInterval(this.animationTimer);
			this.animationTimer = null;
		}
	}

	/**
	 * Handles Rendering of ThreeJS
	 */
	threeRender() {
		this.camera.position.set(0, 355, 500);
		let i = 0;

		for (let ix = 0; ix < this.AMOUNTX; ix++) {
			for (let iy = 0; iy < this.AMOUNTY; iy++) {

				const particle = this.particles[i++];
				particle.position.y = (Math.sin(( ix + this.count ) * 0.3) * 50) + (Math.sin(( iy + this.count ) * 0.5) * 50);
				particle.scale.x = (Math.sin(( ix + this.count ) * 0.3) + 1) * 4 + (Math.sin(( iy + this.count ) * 0.5) + 1) * 4;
				particle.scale.y = particle.scale.x;
			}
		}

		this.count += 0.1;
		this.renderer.render(this.scene, this.camera);
	}

	/**
	 * Window-Resize-Hook. The animation needs to be changed depending on the windowsize
	 */
	onWindowResize() {
		this.camera.aspect = window.innerWidth / window.innerHeight * 1.5;
		this.camera.updateProjectionMatrix();

		this.renderer.setSize(window.innerWidth, window.innerHeight / 1.5);
	}

	/**
	 * Visibility-Hook. So we can save resources when the animation is not visible.
	 * @param isVisible
	 */
	onVisibilityChange(isVisible) {

		this.isVisible = isVisible;

		if(isVisible && this.renderer && !this.animationTimer) {
			this.threeAnimate();
		} else if(!isVisible) {
			this.threeStopAnimate();
		}
	}

	render() {
		return (
			<VisibilitySensor onChange={this.onVisibilityChange} partialVisibility>
				<OutroBackgroundStyle id="three-canvas" >
					<ReactResizeDetector handleWidth handleHeight onResize={ this.onWindowResize } />
				</OutroBackgroundStyle>
			</VisibilitySensor>
		)
	}
}

export default OutroThree;


// WEBPACK FOOTER //
// /opt/build/repo/src/components/OutroThree.js